import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TestHotspotFormFeedback from './TestHotspotFormFeedback'
import TestHotspotFormFont from './TestHotspotFormFont'
import TestHotspotFormStyle from './TestHotspotFormStyle'
import type { TestHotspotFormBrandType, TestHotspotBrandForms } from './testHotspotTypes'

const FORM_MAP: TestHotspotBrandForms = {
  ...(TestHotspotFormFont as TestHotspotBrandForms),
  [BrandFormEnum.STYLE]: TestHotspotFormStyle,
  [BrandFormEnum.FEEDBACK]: TestHotspotFormFeedback,
}

const TestHotspotFormBrand: TestHotspotFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(TestHotspotFormBrand) as typeof TestHotspotFormBrand
